module.exports = __webpack_public_path__ + "img/cicd-hero.515d91ce.svg";